// extracted by mini-css-extract-plugin
export default {"radio":"MGInputRadioButton_radio__ZUqU+","input":"MGInputRadioButton_input__OWrlG","visual":"MGInputRadioButton_visual__-OWMe","inner":"MGInputRadioButton_inner__6201S"};